import type { TrialInDatabaseForAlgolia } from '../types/TrialInDatabaseForAlgolia'

/**
 * Returns a unique array of treatment names including their alternative names.
 */
export function getTreatmentNamesWithAlternates(
  treatments: Pick<TrialInDatabaseForAlgolia, 'treatments'>['treatments'],
) {
  const names = treatments.map((treatment) => treatment.name)
  const alternates = treatments.flatMap((treatment) =>
    treatment.alternativeNames.map((alternate) => alternate),
  )
  const uniqueTreatmentNamesWithAlternates = Array.from(
    new Set([...names, ...alternates]),
  )

  return uniqueTreatmentNamesWithAlternates
}
